import {Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {WebApiHttp} from "../../../../../@pristinebase/Process/WebApiHttp.services";
import {SessionManageMent} from "../../../../../@pristinebase/Process/SessionManageMent";

@Component({
  selector: 'app-attendence-pop-up',
  templateUrl: './attendence-pop-up.component.html',
  styleUrls: ['./attendence-pop-up.component.scss']
})
export class AttendencePopUpComponent implements OnInit {

  type: string = ''
  init: boolean = true;
  stream = null;
  location: string ='';
  LocationArray: Array<string>=['HeadQuarter', 'Ex-Station', 'OutStation', 'In Transit', 'Other'];
  @ViewChild('canvas',{static: true}) canvas: ElementRef
  @ViewChild('video',{static: true}) video: ElementRef
  @ViewChild('image',{static: true}) image: ElementRef
  @ViewChild('attendance',{static: false}) attendence : TemplateRef<any>
  @ViewChild('leave',{static: false}) leave : TemplateRef<any>
  from: string='';
  to: string='';

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private webApiHttp: WebApiHttp,
              private _dig: MatDialog,
              private _sessionManagement: SessionManageMent) { }

  ngOnInit() {
    this.getTodaysAttendencee()
  }
  getTodaysAttendencee(){
    let day = new Date().getDate()
    let month = new Date().getMonth()
    let year = new Date().getFullYear()
    this.webApiHttp.Get(this.webApiHttp.ApiURLArray.getTodaysAttendence +
        this._sessionManagement.getEmail+'&working_date='+year+'/'+month+'/'+day).then(res=>{
      if(res.length>0 && res[0].condition.toString().toLowerCase() == 'false'){

      }else{
        this._dig.closeAll()
      }
    }).catch(err=> console.log(err))
  }

  closeInit(){
    if(this.type=='work'){
      this._dig.closeAll()
      this._dig.open(this.attendence,{disableClose:true, minWidth: '550px', minHeight: '300px'})
    }
  }

  async getMedia(param){
    try{
      this.stream = await navigator.mediaDevices.getUserMedia({video: true})
      console.log(this.stream, param)
    }catch(err){
      console.log(err)
    }
  }

  closeCamera(){
    this.stream.getTracks().forEach((track)=>{
      track.stop()
    })
  }

  imageCapture(){
    setTimeout(()=>{
      this.canvas.nativeElement.getContext('2d').drawImage(this.video.nativeElement(0,0,400,400))
      this.image.nativeElement.setAttribute('src', this.canvas.nativeElement.toDataURL('image/png'))
    }, 100)

  }
}
